import React, { useState, useEffect } from 'react'
import { Button, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import AdsFiltersPanelHolder from '../styles/adsFiltersPanelStyle'

const { Option } = Select

const AdsFiltersPanel = ({ filters, onApply }) => {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(filters)

  useEffect(() => {
    setDraft(filters)
  }, [filters])

  const setField = (field) => (value) => {
    setDraft((prev) => ({ ...prev, [field]: value }))
  }

  return (
    <AdsFiltersPanelHolder>
      <div className="field">
        <label>{t('Type')}</label>
        <Select
          value={draft.type || undefined}
          onChange={setField('type')}
          placeholder={t('Ad type')}
          allowClear
        >
          <Option value="image">{t('Image')}</Option>
          <Option value="video">{t('Video')}</Option>
        </Select>
      </div>

      <Button
        type="primary"
        className="apply-button"
        onClick={() => onApply(draft)}
      >
        {t('Apply')}
      </Button>
    </AdsFiltersPanelHolder>
  )
}

export default AdsFiltersPanel
